import React, { CSSProperties, useEffect, useState } from "react";
import { NavBar, TabBar } from "antd-mobile";
import { AppOutline, AppstoreOutline, UserOutline } from "antd-mobile-icons";
import MessageScreen from "../../screens/MessageScreen";
import WorkplaceScreen from "../../screens/WorkplaceScreen";
import MineScreen from "../../screens/MineScreen";

const Tabs: React.FC = React.memo((props) => {
  const [activeKey, setActiveKey] = useState<string>("message");
  const [title, setTitle] = useState<string>("首页");

  const setRouteActive = (value: string) => {
    setActiveKey(value);
  };

  const tabs = [
    {
      key: "message",
      title: "首页",
      icon: <AppOutline />,
    },
    {
      key: "workplace",
      title: "工作台",
      icon: <AppstoreOutline />,
    },
    {
      key: "mine",
      title: "我的",
      icon: <UserOutline />,
    },
  ];

  const renderContent = () => {
    switch (activeKey) {
      case "message":
        return (
          <div style={contentStyles}>
            <MessageScreen />
          </div>
        );
      case "workplace":
        return (
          <div style={contentStyles}>
            <WorkplaceScreen />
          </div>
        );
      case "mine":
        return (
          <div style={contentStyles}>
            <MineScreen />
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    switch (activeKey) {
      case "message":
        setTitle("首页");
        break;
      case "workplace":
        setTitle("工作台");
        break;
      case "mine":
        setTitle("我的");
        break;
      default:
        break;
    }
  }, [activeKey]);

  return (
    <div style={container}>
      <div style={top}>
        <NavBar back={null}>{title}</NavBar>
      </div>
      <div style={body}> {renderContent()}</div>
      <div style={bottom}>
        <TabBar
          activeKey={activeKey}
          onChange={(value) => setRouteActive(value)}
          defaultActiveKey="message"
        >
          {tabs.map((item, index) => (
            <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
          ))}
        </TabBar>
      </div>
    </div>
  );
});

const top: CSSProperties = {
  flex: 0,
  borderBottom: "solid 1px var(--adm-border-color)",
};

const body: CSSProperties = {
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
};

const bottom: CSSProperties = {
  flex: 0,
  borderTop: "solid 1px var(--adm-border-color)",
};

const container: CSSProperties = {
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  background: "#ff",
};

const contentStyles: CSSProperties = {
  height: "fitContent",
};

export default Tabs;
